/** A user's own page gives each tab its own route, `/users/:id/<tab>` (`recordTabRoutes`). */
export const USER_TABS = ['details', 'history'] as const;
export type UserTab = (typeof USER_TABS)[number];

export const USER_TAB_LABELS: Record<UserTab, string> = { details: 'Details', history: 'History' };

export function userPath(id: string): string {
  return `/users/${id}`;
}

export function userTabPath(id: string, tab: UserTab): string {
  return `${userPath(id)}/${tab}`;
}
